/* Vonari: one-unit color replacement, preserving all bundle properties. */
(function () {
  'use strict';
  const productId = 10269274833224;
  const stable = obj => JSON.stringify(Object.keys(obj || {}).sort().map(k => [k, obj[k]]));
  const signature = item => `${item.variant_id || item.id}|${item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || ''}|${stable(item.properties)}`;
  function counts(cart) {
    const map = new Map();
    cart.items.forEach(item => {const k=signature(item); map.set(k,(map.get(k)||0)+item.quantity);});
    return map;
  }
  function sameCounts(a,b) {
    const keys=new Set([...a.keys(),...b.keys()]);
    return [...keys].every(k=>(a.get(k)||0)===(b.get(k)||0));
  }
  function payload(item,quantity) {
    const out={id:item.variant_id||item.id,quantity,properties:{...item.properties}};
    const plan=item.selling_plan_allocation?.selling_plan?.id||item.selling_plan;
    if(plan)out.selling_plan=plan;
    return out;
  }
  // Restore just the two affected variant/property groups, never clear the cart.
  async function restore(api,before,affected) {
    const wanted=counts(before);
    for(const key of affected) {
      let now=await api('cart.js');
      let have=counts(now).get(key)||0, want=wanted.get(key)||0;
      if(have>want) {
        for(const line of now.items.filter(i=>signature(i)===key)) {
          if(have<=want)break;
          const remove=Math.min(line.quantity,have-want);
          await api('cart/change.js',{id:line.key,quantity:line.quantity-remove});
          now=await api('cart.js'); have=counts(now).get(key)||0;
        }
      } else if(have<want) {
        const original=before.items.find(i=>signature(i)===key);
        if(!original)throw new Error('restore-source-missing');
        await api('cart/add.js',{items:[payload(original,want-have)]});
      }
    }
    const final=await api('cart.js');
    if(!sameCounts(counts(before),counts(final))||before.total_price!==final.total_price)throw new Error('restore-incomplete');
    return final;
  }
  async function changeOne(api,key,variant) {
    const before=await api('cart.js');
    const source=before.items.find(i=>i.key===key);
    if(!source||Number(source.product_id)!==productId)throw new Error('stale-cart');
    if(Number(source.variant_id||source.id)===Number(variant))return before;
    const replacement={...source,id:Number(variant),variant_id:Number(variant)};
    const oldSig=signature(source),newSig=signature(replacement), expected=counts(before);
    expected.set(oldSig,expected.get(oldSig)-1);
    expected.set(newSig,(expected.get(newSig)||0)+1);
    try {
      // The app's documented-in-source ignore flag prevents a new bundle being added.
      await api('cart/add.js',{items:[payload(replacement,1)]});
      const added=await api('cart.js');
      const desiredAdded=counts(before);desiredAdded.set(newSig,(desiredAdded.get(newSig)||0)+1);
      if(!sameCounts(desiredAdded,counts(added)))throw new Error('cart-changed');
      // Discount allocation can split/re-key equal variants. Resolve the fresh key.
      const oldLine=added.items.find(i=>i.key===key&&signature(i)===oldSig)||added.items.find(i=>signature(i)===oldSig);
      if(!oldLine)throw new Error('source-missing');
      await api('cart/change.js',{id:oldLine.key,quantity:oldLine.quantity-1});
      const after=await api('cart.js');
      if(!sameCounts(expected,counts(after))||after.total_price!==before.total_price||after.item_count!==before.item_count)throw new Error('cart-integrity');
      return after;
    } catch(error) {
      try {await restore(api,before,[oldSig,newSig]);} catch(restoreError) {error.recoveryFailed=true;}
      throw error;
    }
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={changeOne,counts,signature,sameCounts};return;}
  const config=document.getElementById('vnr-cart-colors-config');
  if(!config || (config.dataset.enabled!=='true'&&new URLSearchParams(location.search).get('vnr_cart_colors')!=='qa'))return;
  if(window.vnrCartColorsLoaded)return;window.vnrCartColorsLoaded=true;
  const lang=(document.documentElement.lang||'en').slice(0,2);
  const strings={es:{item:'Paraguas',choose:'Cambiar color',saving:'Actualizando…',error:'No se ha podido cambiar el color. Inténtalo de nuevo.',recovery:'No se ha podido completar el cambio. Revisa las cantidades antes de continuar.',unavailable:'Agotado',done:'Color actualizado',close:'Cerrar'},it:{item:'Ombrello',choose:'Cambia colore',saving:'Aggiornamento…',error:'Impossibile cambiare colore. Riprova.',recovery:'Impossibile completare la modifica. Controlla le quantità prima di continuare.',unavailable:'Esaurito',done:'Colore aggiornato',close:'Chiudi'},en:{item:'Umbrella',choose:'Change color',saving:'Updating…',error:'Unable to change the color. Please try again.',recovery:'Unable to complete the change. Check quantities before continuing.',unavailable:'Sold out',done:'Color updated',close:'Close'}};
  const t=strings[lang]||strings.en;
  const root=window.Shopify?.routes?.root||'/';
  async function api(path,data) {
    const url=root+path+(path.includes('?')?'&':'?')+'moonbundle_ignore=true';
    const response=await fetch(url,{method:data?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||'request-failed');
    return result;
  }
  let variants=[],cart=null,busy=false,syncing=false,timer,queued=false;
  const rowSelector='.moonbundle-cart-item[data-item-key]';
  const status=document.createElement('div');status.className='vnr-color-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');document.body.append(status);
  function tell(message,error=false){status.textContent=message;status.classList.toggle('vnr-error',error);status.hidden=!message;}
  tell('');
  function render() {
    if(!cart||!variants.length||busy)return;
    let number=0;
    document.querySelectorAll(rowSelector).forEach(row=>{
      let line=cart.items.find(i=>i.key===row.dataset.itemKey);
      // Moon can expose a re-keyed discounted line before its Ajax cart sync.
      // Only accept an unambiguous variant/quantity/free-status match.
      if(!line) {
        const href=row.querySelector('.moonbundle-cart-item-title-link')?.getAttribute('href');
        const id=href?Number(new URL(href,location.origin).searchParams.get('variant')):0;
        const quantity=Number(row.querySelector('.moonbundle-quantity-input')?.value);
        const free=!!row.querySelector('.moonbundle-cart-item-gift-icon');
        const candidates=cart.items.filter(i=>i.variant_id===id&&i.quantity===quantity&&(i.final_line_price===0)===free);
        if(candidates.length===1)line=candidates[0];
      }
      if(!line||Number(line.product_id)!==productId)return;
      const current=variants.find(v=>v.id===line.variant_id);
      if(!current)return;
      const start=number;number+=line.quantity;
      const stamp=`${line.key}|${line.quantity}|${start}|${lang}`;
      if(row.querySelector('.vnr-cart-colors')?.dataset.stamp===stamp)return;
      row.querySelector('.vnr-cart-colors')?.remove();
      const box=document.createElement('div');box.className='vnr-cart-colors';box.dataset.stamp=stamp;
      const units=document.createElement('div');units.className='vnr-color-units';box.append(units);
      for(let i=0;i<line.quantity;i++) {
        const select=document.createElement('select');select.className='vnr-unit-color';
        select.dataset.key=line.key;select.dataset.number=start+i+1;
        select.setAttribute('aria-label',`${t.item} ${start+i+1}: ${t.choose}`);
        variants.forEach(variant=>{
          const option=document.createElement('option');option.value=String(variant.id);
          option.textContent=variant.title;option.disabled=!variant.available;
          option.selected=variant.id===current.id;select.append(option);
        });
        units.append(select);
        select.addEventListener('change',event=>{
          event.stopPropagation();
          if(busy){select.value=String(current.id);return;}
          if(Number(select.value)!==current.id)commit(line.key,Number(select.value));
        });
      }
      const options=row.querySelector('.moonbundle-product-options');
      if(options)options.after(box);else row.querySelector('.moonbundle-cart-item-details')?.append(box);
      row.classList.add('vnr-has-colors');
    });
  }
  async function sync() {
    if(busy){queued=true;return;}if(syncing)return;syncing=true;
    try {
      if(!document.querySelector(rowSelector))return;
      if(!variants.length)variants=(await api('products/vonari-stormhook-umbrella.js')).variants;
      cart=await api('cart.js');render();
    }catch(error){console.warn('Vonari cart colors:',error.message);}finally{syncing=false;}
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(sync,120);}
  async function commit(key,variant) {
    if(busy)return;busy=true;document.querySelectorAll('select.vnr-unit-color').forEach(e=>e.disabled=true);tell(t.saving);
    document.documentElement.classList.add('vnr-cart-colors-busy');
    try {
      cart=await changeOne(api,key,variant);
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated',{detail:{cart,caller:'vonari-cart-colors'}}));
      tell(t.done);setTimeout(()=>{if(!busy)tell('');},2500);
    }catch(error){
      tell(error.recoveryFailed?t.recovery:t.error,true);
      try{cart=await api('cart.js');window.dispatchEvent(new CustomEvent('moonbundle-cart-updated',{detail:{cart,caller:'vonari-cart-colors-recovery'}}));}catch(_){}
      console.warn('Vonari color change:',error.message);
    }finally{
      busy=false;queued=false;document.querySelectorAll('.vnr-cart-colors').forEach(e=>e.remove());document.documentElement.classList.remove('vnr-cart-colors-busy');schedule();
    }
  }
  // Freeze cart actions during the two-step replacement, including keyboard checkout.
  document.addEventListener('click',event=>{if(busy&&event.target.closest('#moonbundle-cart-drawer,cart-drawer,.moonbundle-cart-drawer-content')){event.preventDefault();event.stopImmediatePropagation();}},true);
  document.addEventListener('submit',event=>{if(busy&&event.target.closest('#moonbundle-cart-drawer,cart-drawer')){event.preventDefault();event.stopImmediatePropagation();}},true);
  const observer=new MutationObserver(records=>{
    if(records.every(r=>r.target.closest?.('.vnr-cart-colors,.vnr-color-status')))return;
    const rows=[...document.querySelectorAll(rowSelector)];
    if(rows.some(r=>!r.querySelector('.vnr-cart-colors')&&r.querySelector('a[href*="/products/vonari-stormhook-umbrella"]')))schedule();
  });
  observer.observe(document.body,{childList:true,subtree:true});
  window.addEventListener('moonbundle-cart-updated',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('click',event=>{if(event.target.closest('#cart-icon-bubble'))schedule();});
  schedule();
})();
